import { render, staticRenderFns } from "./PeriodsComparisonWidgetChart.vue?vue&type=template&id=d8fa834c"
import script from "./PeriodsComparisonWidgetChart.vue?vue&type=script&lang=js"
export * from "./PeriodsComparisonWidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports